// eslint-disable-next-line @typescript-eslint/no-explicit-any
/** Sitecore checkbox may arrive as boolean true, "1", or 1. */
export const isHeaderNavLinkHidden = (item: any): boolean => {
  const value = item?.fields?.["Hide Link"]?.value ?? item?.fields?.HideLink?.value;
  return value === true || value === "1" || value === 1 || value === "true";
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const findHeaderNavItemMatch = (links: any[], target: string): string[] => {
  const matchedIds: string[] = [];

  // Normalize target: remove protocol+domain and lowercase
  const cleanTarget = target.replace(/^https?:\/\/[^\/]+/, "").toLowerCase();

  const isExactMatch = (url: string, query?: string): boolean => {
    if (!url) return false;

    // Combine href + querystring
    let combinedUrl = url;
    if (query) {
      combinedUrl += query.startsWith("?") ? query : `?${query}`;
    }

    // Normalize combined url like target
    const cleanUrl = combinedUrl.replace(/^https?:\/\/[^\/]+/, "").toLowerCase();

    // Exact match check
    return cleanUrl === cleanTarget;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const traverseMenu = (item: any, parentId: string) => {
    // Check the current item's link
    const href = item?.fields?.Link?.value?.href;
    const query = item?.fields?.Link?.value?.querystring;

    if (href && isExactMatch(href, query)) {
      matchedIds.push(parentId);
    }

    // Traverse SubMenuSection
    if (Array.isArray(item?.fields?.SubMenuSection)) {
      for (const subItem of item.fields.SubMenuSection) {
        // Check subItem's link
        const subHref = subItem?.fields?.Link?.value?.href;
        const subQuery = subItem?.fields?.Link?.value?.querystring;
        if (subHref && isExactMatch(subHref, subQuery)) {
          matchedIds.push(parentId);
        }

        // Traverse InnerMenuSection
        if (Array.isArray(subItem?.fields?.InnerMenuSection)) {
          for (const innerItem of subItem.fields.InnerMenuSection) {
            const innerHref = innerItem?.fields?.Link?.value?.href;
            const innerQuery = innerItem?.fields?.Link?.value?.querystring;
            if (innerHref && isExactMatch(innerHref, innerQuery)) {
              matchedIds.push(parentId);
            }

            // Handle deeper nested InnerMenuSection if exists
            if (Array.isArray(innerItem?.fields?.InnerMenuSection)) {
              traverseMenu(innerItem, parentId); // Recursive call for deeper nesting
            }
          }
        }
      }
    }
  };

  for (const link of links) {
    traverseMenu(link, link.id);
  }

  // Remove duplicates and return unique IDs
  return target === "/" ? [] : [...new Set(matchedIds)];
};
